import styled from 'styled-components';
import { SIZING } from '../../styles/variables';

export const EditLocationWrapper = styled.div`
  margin-top: ${SIZING.unit(1.5)};
  margin-left: ${SIZING.unit(1.5)};
  margin-right: ${SIZING.unit(7)};
`;

export const AddressInputWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
`;
